// Module
var code = `<table class="table no-print" ng-table="\$ctrl.noteTableConfig">
  <thead>
  <tr ng-if="\$ctrl.productId" command-access="{{\$ctrl.getCommandName()}}">
    <td colspan="5">
      <button type="button"
              class="btn btn-success"
              ng-click="\$ctrl.showNoteModal('CREATE')">
        Add
      </button>
    </td>
  </tr>
  <tr>
    <th class="note-history__index">No</th>
    <th class="note-history__date">Date and time</th>
    <th class="note-history__content">Description</th>
    <th class="note-history__user">User</th>
    <th class="note-history__username">Username</th>
    <th class="note-history__action" command-access="{{\$ctrl.getUpdateCommandName()}}">Action</th>
  </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in \$data">
      <td class="note-history__index">{{\$index + 1 + (\$ctrl.noteTableConfig.page() - 1) * \$ctrl.noteTableConfig.count()}}</td>
      <td class="note-history__date">{{(item.createdOn) | prettyDateTime }}</td>
      <td class="note-history__content">
        <div ng-repeat="row in item.description track by \$index">{{row}}</div>
      </td>
      <td class="note-history__user">{{\$ctrl.getUser(item.userId) ? \$ctrl.getUser(item.userId).fullName : "-"}}</td>
      <td class="note-history__username">{{\$ctrl.getUser(item.userId) ? \$ctrl.getUser(item.userId).username : "-"}}</td>
      <td class="note-history__action" command-access="{{\$ctrl.getUpdateCommandName()}}">
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.showNoteModal('UPDATE', item)">Update</button>
      </td>
    </tr>
  </tbody>
</table>

<modal on-api-ready="\$ctrl.onNoteModalApiReady">
  <modal-header>
    <h2 ng-if="\$ctrl.modalMode === 'CREATE'">Create note</h2>
    <h2 ng-if="\$ctrl.modalMode === 'UPDATE'">Update note</h2>
  </modal-header>
  <modal-body>
    <p>Please enter description, separated by comma (,)</p>
    <ng-form name="\$ctrl.modalForm">
      <textarea class="note-history__input_desc" rows="4" required maxlength="1000" ng-model="\$ctrl.note.description"></textarea>
    </ng-form>
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.noteModalApi.onCancel()" class="btn">Cancel</button>
    <button type="submit" ng-click="\$ctrl.confirmModal()" ng-disabled="!\$ctrl.modalForm.\$valid" class="btn btn-success">
      {{\$ctrl.modalMode === 'CREATE' ? 'Create' : 'Update'}}
    </button>
  </modal-footer>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/note-history/note-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;